@for (_ of snowflakes; track _) {
	<div class="snow"></div>
}

<!--https://codepen.io/alphardex/pen/dyPorwJ Für Snow Effect (<div class="snow"></div>)[200x] -->
<mat-toolbar>
	<div class="welcome">
		<span class="mep-text-huge"
			>{{ "mep.components.homescreen.welcome-back" | translate }}
			<span class="ms-4 mep-text-huge-primary">{{ userFirstName }}</span>
			@if (email === "STEFAN.FRANK@MSG.GROUP") {
				<span class="ms-4 mep-text-huge-primary">:)</span>
			}
		</span>
	</div>

	<span class="toggleAndNotes" [class.with-role-select]="isAdmin || isAdminTempOff">
		@if (isAdmin || isAdminTempOff) {
			<mat-form-field class="role-select lessPadding">
				<mat-label>{{ "mep.components.role.ROLE_LABEL" | translate }}</mat-label>
				<mat-select [ngModel]="selectedAdminRole" (ngModelChange)="switchAdminRole($event)">
					@for (role of switchableRoles; track role) {
						<mat-option
							[value]="role"
							[matTooltip]="'mep.components.role.SWITCH_' + role + '_TOOLTIP' | translate"
							matTooltipPosition="right"
						>
							{{ "mep.components.role.SWITCH_" + role | translate }}
						</mat-option>
					}
				</mat-select>
			</mat-form-field>
		}
		@if (!appearanceService.experimentalFeatures.deactivateUselessNavbarButtons.signal()) {
			<a
				target="_blank"
				rel="noopener noreferrer"
				[href]="releaseNotesLink"
				matTooltip="{{ 'mep.components.general.release-notes' | translate }}"
				[matTooltipClass]="{'tooltip-position': true}"
			>
				<span class="version">
					V{{ version }} ,
					<small>
						{{ "mep.components.general.deployed-at" | translate }}
						{{ lastModifiedDate | date: "dd.MM.yy HH:mm" }}</small
					>
				</span>
			</a>
		}
	</span>
</mat-toolbar>

@if (viewCockpit && user) {
	<div class="cockpit-layout">
		<div style="flex: 1">
			<app-mec-data class="cockpit-left" [user]="user" [cockpitBusinessUnits]="cockpitBusinessUnits"></app-mec-data>
		</div>
		@if (hasUnreadNotifications) {
			<div class="cockpit-notifications-container">
				<app-assignments-notification-dialog
					class="cockpit-right"
					[isDialog]="false"
					[showHeader]="true"
					[showPagination]="false"
					[showActions]="true"
				>
				</app-assignments-notification-dialog>
			</div>
		}
		<div class="mep-last-separator"></div>
	</div>
}

<div cdkDropListGroup [ngClass]="viewCockpit ? 'mep-cockpit-view' : 'mep-cards'">
	<div cdkDropList (cdkDropListDropped)="dropListDropped()" (cdkDropListEntered)="cdkDropListEntered($event)"></div>
	@for (favorite of favorites; track favorite.id) {
		<div
			class="scrollbox"
			cdkDropList
			(cdkDropListDropped)="dropListDropped()"
			(cdkDropListEntered)="cdkDropListEntered($event)"
		>
			@if (favorite.card === 1) {
				<div>
					<div *appRequiresPermission="favorite.reqPermission; entity: favorite.linkEntity">
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			@if (
				(favorite.card < 15 && favorite.card > 1 && favorite.card !== 11 && favorite.card !== 12) || favorite.card >= 20
			) {
				<div>
					<div *appRequiresPermission="favorite.reqPermission; entity: favorite.linkEntity">
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			@if (favorite.card === 11 || favorite.card === 12) {
				<div>
					<div *appRequiresPermission="favorite.reqPermission; entity: favorite.linkEntity">
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			<!-- for all roles: skill edit and display my profile -->
			@if ((favorite.card === 15 || (favorite.card === 16 && !deactivateSkillEdit)) && !isCustomerManager && !isExternal) {
				<div>
					<div *appRequiresPermission="favorite.reqPermission; entity: favorite.linkEntity; idNotRelevant: true">
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			<!-- for readonly ma_skill_edit -->
			@if (favorite.card === 17) {
				<div>
					<div
						*appRequiresPermission="
							favorite.reqPermission;
							entity: favorite.linkEntity;
							exactMatch: true;
							idNotRelevant: true
						"
					>
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			<!-- for readonly ma_skills_proj -->
			@if (favorite.card === 18) {
				<div>
					<div
						*appRequiresPermission="
							favorite.reqPermission;
							entity: favorite.linkEntity;
							exactMatch: true;
							idNotRelevant: true
						"
					>
						@if (favorite.enabled) {
							<a [routerLink]="[favorite.routeLink + applicationUser.employee.id]" cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="favorite.approach && this[favorite.approach]()"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
			@if (favorite.card === 19) {
				<div>
					<div
						*appRequiresPermission="
							favorite.reqPermission;
							entity: favorite.linkEntity;
							exactMatch: true;
							idNotRelevant: true
						"
					>
						@if (favorite.enabled) {
							<a cdkDrag>
								<mat-card
									[ngClass]="viewCockpit ? 'mep-dashboard-btn-small' : 'mep-dashboard-btn'"
									(click)="openAssignEmployeeDialog(applicationUser.employee)"
								>
									<mat-icon svgIcon="{{ favorite.icon }}"></mat-icon>
									<mat-card-title>
										{{ favorite.label | translate }}
									</mat-card-title>
								</mat-card>
							</a>
						}
					</div>
				</div>
			}
		</div>
	}

	<mat-card
		[ngClass]="viewCockpit ? 'mep-edit-card-small' : 'mep-edit-card'"
		(click)="openEdit()"
		tabindex="0"
		(keydown.enter)="openEdit()"
	>
		<mat-icon svgIcon="mep_add"></mat-icon>
		<mat-card-title>
			{{ "mep.components.homescreen.edit-favorites" | translate }}
		</mat-card-title>
	</mat-card>
</div>
